module.exports = __webpack_public_path__ + "img/智慧路灯管理系统软件V1.0.f189255e.jpg";